import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-howToPlay',
  templateUrl: './howToPlay.component.html',
  styleUrls: ['./howToPlay.component.scss']
})
export class HowToPlayComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
